import React from "react";

import { Typography } from "@mui/material";
import clsx from "clsx";

import mainStyles from "../../styles";

interface HeadingProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const DisplayHeading = ({ children, style }: HeadingProps) => {
  const classes = mainStyles();
  return (
    <Typography
      variant="h6"
      color="textPrimary"
      className={clsx(classes.spaceTopSmall && classes.spaceBottomSmall)}
      style={style}
    >
      {children}
    </Typography>
  );
};

export default DisplayHeading;
